<script setup>
// Modo Pessoal: o corpo é texto. Linha em branco separa parágrafos,
// **negrito** e links viram marcação. Variáveis entram por botão.
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  text: { type: String, default: '' },
});
const emit = defineEmits(['update']);
const { t } = useI18n();

const VARIABLES = [
  '{{primeiro_nome}}',
  '{{nome}}',
  '{{empresa}}',
  '{{vendedor}}',
  '{{remetente}}',
];
const area = ref(null);

const insert = token => {
  const el = area.value;
  const start = el?.selectionStart ?? props.text.length;
  const end = el?.selectionEnd ?? props.text.length;
  const next = `${props.text.slice(0, start)}${token}${props.text.slice(end)}`;
  emit('update', next);
};
</script>

<template>
  <div class="flex h-full min-h-0 flex-col gap-2 p-4">
    <div class="flex flex-wrap items-center gap-1.5">
      <span class="text-[11px] text-n-slate-10">{{
        t('EMAIL_TEMPLATES.BUILDER.PERSONAL.VARIABLES')
      }}</span>
      <button
        v-for="v in VARIABLES"
        :key="v"
        type="button"
        class="rounded-md bg-n-solid-2 px-2 py-0.5 font-mono text-[11px] text-n-slate-11 hover:bg-n-solid-3"
        @click="insert(v)"
      >
        {{ v }}
      </button>
    </div>
    <textarea
      ref="area"
      :value="text"
      class="min-h-0 flex-1 resize-none rounded-xl border border-n-weak bg-n-solid-1 p-4 font-sans text-[15px] leading-relaxed text-n-slate-12 focus:outline-none focus:ring-1 focus:ring-n-brand"
      :placeholder="
        t('EMAIL_TEMPLATES.BUILDER.PERSONAL.PLACEHOLDER', {
          name: VARIABLES[0],
        })
      "
      @input="emit('update', $event.target.value)"
    />
    <p class="text-[11px] text-n-slate-10">
      {{ t('EMAIL_TEMPLATES.BUILDER.PERSONAL.HINT') }}
    </p>
  </div>
</template>
